<script setup>

const route = useRoute()
const url = useRequestURL()

const { data: page } = await useAPIFetch(`Podcast/${route.params.slug}`)

if (!page.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found',
		fatal: true
  })
}

useHeadData({
	title: page.value.meta.title,
	description: page.value.meta.description,
	author: page.value.meta.author,
	copyright: page.value.meta.copyright,
	keywords: page.value.meta.keywords,
	og: page.value.meta.og,
	url: url.href
})

</script>

<template>
	<div class="container">
		<ArticleHeader class="mb-10 xl:mb-20" :title="page.attrs.title" :date="page.attrs.published" :type="page.type" :podcastSection="page.attrs.section.attrs.title" />

		<div class="flex justify-center mb-10 xl:mb-20"><NuxtImg :src="page.attrs.image.url" /></div>
		<div class="xl:grid grid-cols-12 gap-8 mb-10 xl:mb-20">
			<div class="col-span-8 col-start-3">
				<WysiwygPerex :value="page.attrs.perex" />
				

				<!-- article components loop -->
				<div v-for="component in page.body" :key="component.id">
					<div class="mb-12" v-if="component.component === 'Text'" ><WysiwygText  :value="component.content" /></div>
					<div class="mb-12" v-else-if="component.component ==='Video'"><Video :video="component.video" :start="component.start" /></div>
					<div class="mb-12" v-else-if="component.component ==='Track'"><Track color="green" :album="page.attrs.album.attrs" :tracklistUrl="`Podcast/${route.params.slug}/component/${component.id}`" /></div>
				</div>
			</div>
		</div>
	</div>
</template>